<template>
  <div class="map-search">
    <div class="map-search-box">
      <el-form :inline="true" :model="formData" class="demo-form-inline">
        <el-form-item label="">
          <el-radio-group v-model="formData.radio" @change="radioChange">
            <el-radio :label="3">{{ $t('res') || '资源' }}</el-radio>
            <el-radio :label="1">{{ $t('keywords') || '关键字' }}</el-radio>
            <el-radio :label="2">{{ $t('lon_lat') || '经纬度' }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="map-search-btn">
          <el-button type="text" @click="onSearch">{{ $t('search') || '搜索' }}</el-button>
          <el-button type="text" @click="onReset">{{ $t('reset') || '重置' }}</el-button>
        </el-form-item>
      </el-form>
      <div>
        <el-autocomplete
          popper-class="my-autocomplete"
          v-model.trim="keyword"
          :fetch-suggestions="remoteMethod"
          :placeholder="$t('pls_enter_keywords') || '请输入关键字'"
          ref="keyComplete"
          @select="selectOption"
          :trigger-on-focus="false"
          v-if="formData.radio === 1 || formData.radio === 3"
        >
          <template slot-scope="{ item }">
            <div class="search-result-item" v-if="formData.radio === 1">
              <div class="location-name">
                <i class="el-icon-location-information"></i> {{ item.name }}
              </div>
              <div class="address-desc">{{ $t('address') || '地址' }}：{{ item.address }}</div>
            </div>
            <div v-else class="search-result-item">
              <div class="mb-xxs location-name">
                <i class="resource-icon-front" v-if="item.searchType === 'resource'"></i>
                <i class="device-icon-front" v-if="item.searchType === 'device'"></i>
                <i class="manual-icon-front" v-if="item.searchType === 'markerManual'"></i>
                {{ item.name }}
              </div>
            </div>
          </template>
        </el-autocomplete>
        <el-input
          v-else
          v-model="keyword"
          :placeholder="placeholder"
          @keyup.enter.native="onSearch"
          id="mapsearchInput"
        ></el-input>
      </div>
    </div>
  </div>
</template>

<script>
import MapInit from '../../utils/mapinit'
import L from 'leaflet'
import httpClient from '../../http'
export default {
  name: 'rg-map-search',
  data() {
    return {
      loading: false,
      selectDatas: [],
      keyword: '',
      min: this.global.configObj.minZoom,
      placeholder: '',
      TiandiMap: null,
      localsearch: null,
      formData: {
        radio: 3
      },
      callback: null,
      searchIcon: '',
      mapSearchMarker: null,
      southWestConfig: this.global.configObj.southWest,
      northEastConfig: this.global.configObj.northEast,
      siteZoom: this.global.configObj.siteZoom || 16,
      regLng: /^-?(?:(?:180(?:\.0{1,14})?)|(?:(?:(?:1[0-7]\d)|(?:[1-9]?\d))(?:\.\d{1,14})?))$/,
      regLat: /^-?(?:90(?:\.0{1,14})?|(?:[1-8]?\d(?:\.\d{1,14})?))$/
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.placeholder = '请输入关键字'
      this.searchIcon = L.icon({
        iconUrl: require('../../assets/image/mapSearch/mapSearchDot.svg'),
        iconSize: [24, 24]
      })
      this.loadTiandiMap()
    },
    radioChange(e) {
      if (e === 1) {
        // 关键字
        this.placeholder = '请输入关键字'
      } else if (e === 2) {
        this.placeholder = '输入经度，纬度(例如:120.255,27.658)'
      } else if (e === 3) {
        this.placeholder = '请输入关键字'
      }
      this.onReset()
    },
    loadTiandiMap() {
      MapInit.init().then((T) => {
        // 初始化地图对象
        this.TiandiMap = new T.Map('tiandiMap')
        // 设置显示地图的中心点和级别
        let tiandiCenter = this.global.mapCenter
        this.TiandiMap.centerAndZoom(
          new T.LngLat(tiandiCenter[1], tiandiCenter[0]),
          this.global.mapZoom
        )
        let config = {
          pageCapacity: 100, // 每页显示的数量
          onSearchComplete: this.localSearchResult // 接收数据的回调函数
        }
        // 创建搜索对象
        this.localsearch = new T.LocalSearch(this.TiandiMap, config)
      })
    },
    onReset() {
      this.keyword = ''
      this.removeMarker()
      this.selectDatas = []
      if (this.callback) {
        this.callback([])
      }
    },
    remoteMethod(queryString, cb) {
      this.$refs.keyComplete.focus()
      queryString = queryString.trim()
      if (queryString === '' || this.formData.radio === 2) {
        return // 经纬度
      }
      this.callback = cb
      if (this.formData.radio === 1) {
        this.localsearch.search(queryString, 1)
      }
      // 资源
      if (this.formData.radio === 3) {
        this.searchResourceName()
      }
    },
    localSearchResult(result) {
      // 根据返回类型解析搜索结果
      let emptyData = [
        {
          name: '没有找到相关地点',
          address: '-',
          isEmpty: true
        }
      ]
      if (result.resultType === 1) {
        if (result.pois && result.pois.length > 0) {
          this.selectDatas = result.pois
        } else {
          // 没有找到相关地点
          this.selectDatas = emptyData
        }
      } else {
        // resultType取值1-5，对应不同的响应类型： 1（普通POI），2（统计），3（行政区)，4（建议词搜索），5（线路结果）
        // 查询结果的resultType!=1的时候，要重新发queryType=4查询。
        // 返回结果是4，用suggests
        if (result.resultType === '4' || result.resultType === 4) {
          if (result.suggests && result.suggests.length > 0) {
            this.selectDatas = result.suggests
          } else {
            // 没有找到相关地点
            this.selectDatas = emptyData
          }
        }
        // 返回结果不是1且不是4，重新用4查询
        if (
          result.resultType === '2' ||
          result.resultType === '3' ||
          result.resultType === '5' ||
          result.resultType === 2 ||
          result.resultType === 3 ||
          result.resultType === 5
        ) {
          this.localsearch.search(this.keyword, 4)
        }
      }
      this.callback(this.selectDatas)
    },
    selectOption(e) {
      if (e.isEmpty) {
        // 点击的无数据
        return
      }
      if (e.searchType) {
        // 点击的资源
        this.selectResource(e)
      } else {
        // 点击的地图关键字搜索
        this.selectLocation(e)
      }
    },
    selectLocation(e) {
      // let latlng = e.lonlat.split(' ').reverse()
      let lnglat = e.lonlat.split(',')
      this.searchdotMarker(lnglat)
      this.keyword = e.name
    },
    selectResource(e) {
      this.keyword = e.name
      if (this.global.historyResourceId) {
        this.global.markerObjResource[this.global.historyResourceId].closeTooltip()
      }
      let latlng = []
      if (e.searchType === 'resource') {
        latlng = [e.lat, e.lng]
        this.global.markerObjResource[e.id].openTooltip()
        this.global.historyResourceId = e.id
      }
      if (e.searchType === 'device') {
        if (e.children && e.children.length > 0) {
          latlng = [e.children[0].latitude, e.children[0].longitude]
        }
      }
      if (e.searchType === 'markerManual') {
        latlng = [e.lngLat[0].lat, e.lngLat[0].lng]
        if (e.markType === '1') {
          // 标点
          this.global.markerObjDot[e.toolId].openPopup()
        } else if (e.markType === '2') {
          // 标线
          this.global.lineObj[e.toolId].openPopup()
        } else if (e.markType === '3') {
          // 标面
          this.global.areaObj[e.toolId].openPopup()
        }
      }
      const zoom = this.siteZoom || this.global.map.getZoom()
      this.global.map.setView(latlng, zoom)
    },
    onSearch() {
      if (this.keyword === '') return
      this.loading = true
      if (this.formData.radio === 1) {
        // 调用关键字检索
        this.$refs.keyComplete.focus()
        this.localsearch.search(this.keyword, 1)
      } else if (this.formData.radio === 2) {
        this.latlngSearch() // 坐标
      } else {
        // 资源名称
        this.$refs.keyComplete.focus()
        this.searchResourceName()
      }
    },
    // 坐标
    latlngSearch() {
      this.keyword = this.keyword.replace(/，/g, ',')
      let lnglat = this.keyword.split(',')
      this.searchdotMarker(lnglat)
    },
    searchdotMarker(lnglat) {
      this.removeMarker()
      if (!lnglat || lnglat.length !== 2) {
        this.$message.warning('请输入正确的经纬度')
        return
      } else {
        if (!this.regLng.test(lnglat[0].trim()) || !this.regLat.test(lnglat[1].trim())) {
          this.$message.warning('请输入正确的经纬度')
          return
        }
      }
      if (
        lnglat[0].trim() < this.southWestConfig[1] ||
        lnglat[0].trim() > this.northEastConfig[1]
      ) {
        this.$message.warning('经度超出当前地图区域')
        return
      }
      if (
        lnglat[1].trim() < this.southWestConfig[0] ||
        lnglat[1].trim() > this.northEastConfig[0]
      ) {
        this.$message.warning('纬度超出当前地图区域')
        return
      }

      let latlngMap = lnglat.reverse()
      this.mapSearchMarker = L.marker(latlngMap, {
        icon: this.searchIcon,
        class: 'map-search-marker',
        draggable: false
      }).addTo(this.global.map)
      const zoom = this.siteZoom || this.global.map.getZoom()
      this.global.map.setView(latlngMap, zoom)
    },
    removeMarker() {
      if (this.mapSearchMarker) {
        this.global.map.removeLayer(this.mapSearchMarker)
      }
    },
    // 资源名称
    searchResourceName() {
      let info = {
        searchName: this.keyword.trim()
      }
      httpClient({
        url: '/api-forest/resourceInfo/searchByName',
        method: 'get',
        params: info
      }).then((res) => {
        this.loading = false
        if (res.resp_code === 0) {
          let data = res.data || {
            resourceInfoList: [],
            deviceTreeList: [],
            markerLocationList: []
          }
          if (data.resourceInfoList.length > 0) {
            data.resourceInfoList.forEach((item) => {
              item.name = item.title
              item.searchType = 'resource'
            })
          }
          if (data.deviceTreeList.length > 0) {
            data.deviceTreeList.forEach((item) => {
              item.name = item.displayName
              item.searchType = 'device'
            })
          }
          if (data.markerLocationList.length > 0) {
            data.markerLocationList.forEach((item) => {
              item.searchType = 'markerManual'
            })
          }
          this.selectDatas = [
            ...data.resourceInfoList,
            ...data.deviceTreeList,
            ...data.markerLocationList
          ]
          if (this.selectDatas.length > 0) {
            this.callback(this.selectDatas)
          } else {
            this.callback([{ name: '暂无数据', isEmpty: true }])
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$fontColor: #d9dde5;
$mainColor: #d9dde5;
$disableColor: #838ba5;
.map-search {
  position: absolute;
  z-index: 1002;
  left: 82px;
  top: 10px;
  .map-search-box {
    padding: 5px 10px 10px 10px;
    font-size: 14px;
    background: rgba(31, 72, 73, 0.8);
    border-radius: 5px;
  }
  .map-search-btn {
    margin-left: 20px;
  }
}
.location-name {
  font-size: 14px;
  height: 24px;
  line-height: 24px;
  margin-top: 5px;
}
.address-desc {
  font-size: 12px;
  height: 24px;
  line-height: 24px;
  margin-bottom: 5px;
}
::v-deep {
  .el-input__inner {
    width: 322px;
    height: 32px;
    font-size: 12px !important;
    background: url('../../assets/image/mapSearch/shield_input_default@2x.png') no-repeat;
    background-size: 100% 100%;
    border: 0 none !important;
    color: $mainColor;
    cursor: text !important;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
.search-empty {
  padding: 5px 15px;
  color: $mainColor;
  &:hover {
    background-color: rgba(19, 228, 228, 0.2);
    cursor: pointer;
  }
}
.el-select-dropdown__item.selected {
  color: $mainColor;
}
.resource-icon-front,
.device-icon-front,
.manual-icon-front {
  width: 14px;
  height: 14px;
  background: url('../../assets/image/mapSearch/icon_point_mark@2x.png') no-repeat;
  background-size: 100% 100%;
  display: inline-block;
}
.device-icon-front {
  background: url('../../assets/image/mapSearch/RVC_icon_camera_selected.png') no-repeat;
  background-size: 100% 100%;
}
.manual-icon-front {
  background: url('../../assets/image/mapSearch/icon_point_resource@2x.png') no-repeat;
  background-size: 100% 100%;
}
.el-button--text:hover {
  opacity: 0.8;
  color: $mainColor;
}
.el-autocomplete-suggestion {
  display: none;
}
</style>
